module.exports = __webpack_public_path__ + "static/img/honor9.d1ecf3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor9.png
// module id = btDh
// module chunks = 0